import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

import { AveragePlayerScore, ScoreStatus } from '__generated__/globalTypes';
import { Tooltip } from 'atoms/tooltip/Tooltip';
import { TotalAveragePlayerScore } from 'lib/averagePlayerScore';
import { statusMessages } from 'lib/players';
import { modeTooltipMessages } from 'lib/so5';

import { Score } from '../Score';

type Props = {
  scores: Record<TotalAveragePlayerScore, number | null>;
  mode: TotalAveragePlayerScore;
  remainingPoints?: number;
  hideTooltip?: boolean;
  small?: boolean;
} & Pick<
  ComponentProps<typeof Score>,
  'animated' | 'isCappedMode' | 'shape' | 'size'
>;

const INVERTED: TotalAveragePlayerScore[] = [
  AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE,
  AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE,
];
const NO_BORDER: TotalAveragePlayerScore[] = [
  AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE,
];

export const ScoreByMode = ({
  scores,
  mode,
  isCappedMode,
  remainingPoints,
  animated,
  hideTooltip,
  shape = 'HEXAGON',
  size,
}: Props) => {
  const score = scores[mode];

  const isAffordable =
    remainingPoints !== undefined ? remainingPoints >= (score || 0) : true;

  return (
    <Tooltip
      title={
        <FormattedMessage
          {...(score ? modeTooltipMessages[mode] : statusMessages.DID_NOT_PLAY)}
        />
      }
      skip={hideTooltip}
    >
      <Score
        hideReviewing
        shape={shape}
        score={score || 0}
        scoreStatus={ScoreStatus.FINAL}
        scoreType="PLAYER_SCORE"
        isCappedMode={isCappedMode}
        isAffordable={isAffordable}
        animated={animated}
        inverted={INVERTED.includes(mode)}
        noBorder={NO_BORDER.includes(mode)}
        size={size}
      />
    </Tooltip>
  );
};
